import { ApplicantType, CONTACT_REQUESTS } from '@shared/enums';

export const USER_VOLUNTEER = 'volunteer';
export const USER_IN_NEED = 'in-need';

export const signUpPersonTabsData = [
  {
    label: 'individual-person',
    isActive: false,
    eventKey: ApplicantType.HumanBeing,
  },
  {
    label: 'legal-entity',
    isActive: false,
    eventKey: ApplicantType.LegalEntity,
  },
];

export const profileTabsData = [
  ...signUpPersonTabsData,
  {
    label: 'shared-contacts',
    isActive: false,
    eventKey: CONTACT_REQUESTS,
  },
];
